export default "__VITE_ASSET__BR5B6Rdu__"